import {
  mergeConfig,
  wrapAsDerivedFromMeasurementsConfig as wrap,
} from 'Components/Worksheets/Core/Helpers/configHelpers';
import getMoistureContentDerivedFromMeasurementsConfig from 'Components/Worksheets/MoistureContentWorksheet/derivedFromMeasurementsConfig';

const getDerivedFromMeasurementsConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Masses.WashedDryMass`]: wrap([
        `${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTrays.ContainerMass`,
        `${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTrays.DryMassReadings.DrySoilAndContainerMass`,
      ]),
      [`${prefix}.Masses.ScreeningsDryMass`]: wrap([
        `${prefix}.Masses.MeasuredScreeningsConstantDryMass.DryingTrays.ContainerMass`,
        `${prefix}.Masses.MeasuredScreeningsConstantDryMass.DryingTrays.DryMassReadings.DrySoilAndContainerMass`,
      ]),
      [`${prefix}.Masses.WashingsDryMass`]: wrap([`${prefix}.Masses.WashedDryMass`, `${prefix}.Masses.InitialDryMass`]),
    },
    getMoistureContentDerivedFromMeasurementsConfig(`${prefix}.Masses.MeasuredWashedConstantDryMass`)
  );

export default getDerivedFromMeasurementsConfig;
